import React, { useRef } from 'react';
import styled from 'styled-components/macro';

import { sections } from '../../common/config';
import FooterLinks, { Wrapper as _FooterLinks } from '../../components/FooterLinks';
import useScrollControl from './useScrollControl';
import Landing from './Landing';
import History from './History';
import FAQs from './FAQs';
import Flavor from './Flavor';
import Contact from './Contact';
import WebGL from './WebGL';
import Images from './Images';

const Wrapper = styled.div`
  background-image: url(/static/images/texture.jpg);
`;

const Container = styled.div`
  position: relative;
  
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BufferSpace = styled.section`
  height: ${sections.height.buffer}vh;
`;

const Main = ({ scroll }: { scroll: React.RefObject<HTMLDivElement> }) => {

  const wrapper = useRef<HTMLDivElement>(null);
  const canvas = useRef<HTMLDivElement>(null);

  useScrollControl(wrapper, scroll, canvas);

  return (
    <Wrapper ref={wrapper}>

      <Images />

      <Landing />

      <Container>
        <WebGL ref={canvas} />

        <BufferSpace />
        <History />
        <FAQs />
        <Flavor />
        <Contact />

        <FooterLinks bottom={1} color="black" />
      </Container>

    </Wrapper>
  );
}

export default Main;